import cookies from '../cookies'

export default function setNRFeatureCustomAttributes (win = window) {
  /* We want to set feature flags as new relic custom attribute so that
    we can filter errors by feature flags when rolling out.
    If user in multiple experiments, flags are separated by ':' in the cookie */
  const featureFlags = cookies.get('hb_feature_flags')
  if (featureFlags && win.newrelic && win.newrelic.setCustomAttribute) {
    // eslint-disable-next-line no-unused-expressions
    win.newrelic.setCustomAttribute('hb_feature_flags', featureFlags)
  }
}
